import EditBookingForm from './EditBookingForm'

export default EditBookingForm
